import { LANGUAGES } from 'locale/Translation.consts'
import { styled, css } from 'styled-components'

interface TextProps {
  $withSubtitle?: boolean
}

export const Text = styled.span<TextProps>`
  margin-right: 5px;
  white-space: break-spaces;
  color: ${({ theme }) => theme.colors.black};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  ${({ $withSubtitle }) =>
    $withSubtitle &&
    css`
      line-height: 26px;
    `}

  ${({ theme }) =>
    theme.language === LANGUAGES.JAPANESE &&
    css`
      font-size: 14.5px;
    `}
`

export const DescriptionWrapper = styled.div`
  white-space: pre-line;
  position: relative;
  display: flex;
  gap: 7px;
  font-size: 14.5px;
  font-weight: 400;
  line-height: 15px;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondaryDark};

  ${({ theme }) =>
    theme.language === LANGUAGES.JAPANESE &&
    css`
      font-size: 13px;
    `}
`

export const SummaryHighlightedText = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;

  ${({ theme }) =>
    theme.language === LANGUAGES.JAPANESE &&
    css`
      font-size: 13px !important;
    `}
`

export const Wrapper = styled.div`
  margin-bottom: 8px;
  user-select: none;
`

interface DivProps {
  $strong?: boolean
}

export const Div = styled.div<DivProps>`
  font-weight: ${({ $strong }) => ($strong ? 700 : undefined)};
`

export const BoldDiv = styled.div<DivProps>`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${({ $strong }) => {
    if (!$strong) {
      return undefined
    }
    return 600
  }};

  ${({ theme }) =>
    theme.language === LANGUAGES.JAPANESE &&
    css`
      font-size: 14.5px;
    `}
`
